import { Action } from '@ngrx/store';

export enum FileSignaturesActionType {
    CacheFileSignatures = '[File Signatures] Cache File Signatures',
    RefreshFileSignatures = '[File Signatures] Refresh File Signatures',
    RefreshFileSignaturesSuccess = '[File Signatures] Refresh File Signatures Success',
    RefreshFileSignaturesFailure = '[File Signatures] Refresh File Signatures Failure',
    ClearFileSignatures = '[File Signatures] Clear File Signatures'
}

/**
 * Cache file signatures from messages
 * Called when messages are loaded and signatures need to be cached in Core store
 */
export class CacheFileSignatures implements Action {
    readonly type = FileSignaturesActionType.CacheFileSignatures;
    constructor(public signatures: { [fileId: string]: any }) {} // Map of fileId → AmsFileAccess
}

/**
 * Refresh file signatures by fetching latest from API
 * Triggered when user performs action with expired signature
 */
export class RefreshFileSignatures implements Action {
    readonly type = FileSignaturesActionType.RefreshFileSignatures;
    constructor(public versionId: number) {}
}

/**
 * Refresh succeeded - update cache with fresh signatures
 */
export class RefreshFileSignaturesSuccess implements Action {
    readonly type = FileSignaturesActionType.RefreshFileSignaturesSuccess;
    constructor(public signatures: { [fileId: string]: any }) {}
}

/**
 * Refresh failed
 */
export class RefreshFileSignaturesFailure implements Action {
    readonly type = FileSignaturesActionType.RefreshFileSignaturesFailure;
    constructor(public error: any) {}
}

/**
 * Clear all cached signatures when user leaves version
 */
export class ClearFileSignatures implements Action {
    readonly type = FileSignaturesActionType.ClearFileSignatures;
}

export type FileSignaturesActions =
    | CacheFileSignatures
    | RefreshFileSignatures
    | RefreshFileSignaturesSuccess
    | RefreshFileSignaturesFailure
    | ClearFileSignatures;
